<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2>Incoming riders to the tracker desk</h2>
          <div class="d-flex align-items-center">
            <span v-if="isRefreshing" class="text-muted me-2">
              <i class="fas fa-spinner fa-spin"></i> Refreshing...
            </span>
            <small class="text-muted">
              Auto-refresh every 10s | Last updated: {{ lastUpdated }}
            </small>
          </div>
        </div>
        
        <div v-if="loading && !ridersWithoutTrackers" class="text-center py-4">
          <i class="fas fa-spinner fa-spin fa-2x"></i>
          <p class="mt-2">Loading riders...</p>
        </div>
        
        <div v-else-if="error" class="alert alert-danger">
          <i class="fas fa-exclamation-triangle"></i>
          Error loading riders: {{ error }}
        </div>
        
        <div v-else-if="ridersWithoutTrackers && ridersWithoutTrackers.length === 0" 
             class="alert alert-success">
          <i class="fas fa-check-circle"></i>
          No incoming riders to the tracker desk
        </div>
        
        <div v-else class="card">
          <div class="card-header">
            <h5 class="mb-0">
              {{ ridersWithoutTrackers ? ridersWithoutTrackers.length : 0 }} 
              rider{{ (ridersWithoutTrackers && ridersWithoutTrackers.length !== 1) ? 's' : '' }} 
              need{{ (ridersWithoutTrackers && ridersWithoutTrackers.length === 1) ? 's' : '' }} trackers
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div v-for="capString in ridersWithoutTrackers" 
                   :key="capString" 
                   class="col-md-2 col-sm-3 col-4 mb-2">
                <span class="badge badge-warning badge-lg p-2 w-100 text-center">
                  {{ capString }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "RidersWithoutTrackers",
  data() {
    return {
      ridersWithoutTrackers: null,
      loading: true,
      isRefreshing: false,
      error: null,
      refreshInterval: null,
      lastUpdated: null
    };
  },
  computed: {
    ...mapState(["baseURL"]),
    ...mapState("racesStore", ["selectedRace"]),
  },
  watch: {
    selectedRace(newRace) {
      if (newRace) {
        this.fetchRidersWithoutTrackers();
      }
    }
  },
  mounted() {
    this.fetchRidersWithoutTrackers();
    // Set up auto-refresh every 10 seconds
    this.refreshInterval = setInterval(() => {
      this.fetchRidersWithoutTrackers(true);
    }, 10000);
  },
  beforeDestroy() {
    // Clear the interval to prevent memory leaks
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    async fetchRidersWithoutTrackers(isRefresh = false) {
      if (!this.selectedRace) {
        this.error = "No race selected";
        this.loading = false;
        return;
      }

      try {
        this.isRefreshing = isRefresh;
        if (!isRefresh) {
          this.loading = true;
        }
        this.error = null;

        const raceId = this.selectedRace.uuid || this.selectedRace;
        const response = await axios.get(
          `${this.baseURL}api/v1/races/${raceId}/riders-without-trackers/`
        );
        
        this.ridersWithoutTrackers = response.data;
        this.lastUpdated = new Date().toLocaleTimeString();
      } catch (error) {
        console.error("Error fetching riders without trackers:", error);
        this.error = error.response?.data?.detail || "Failed to fetch data";
      } finally {
        this.loading = false;
        this.isRefreshing = false;
      }
    },
  },
};
</script>

<style scoped>
.badge-lg {
  font-size: 0.9rem;
  padding: 0.5rem 0.75rem;
}

.card-header h5 {
  color: #856404;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
  font-weight: 600;
}
</style>